import * as React from 'react';
import { Select, SelectProps } from 'antd';
import { SelectValue } from 'antd/lib/select';
import './BaseSelect.less';

export type BaseSelectProps = SelectProps<SelectValue>;

const BaseSelect: React.FC<BaseSelectProps> = props => {
    const { className, ...selectProps } = props;

    return <Select className={`base-select ${className || ''}`} {...selectProps} />;
};

export default BaseSelect;
